





























/**
 * Originally took from:
 * https://mazipan.github.io/vue-doughnut-chart
 *
 * Rewritten by Vladimir Stadnik <vladimir.stadnik@cimpleo.com>
 * to TypeScript component
 */
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DoughnutChart extends Vue {
  @Prop({ default: () => 0 })
  private readonly percent!: number;

  @Prop({ default: () => "" })
  private readonly title!: string;

  @Prop({ default: () => "#1993ff" })
  private readonly foregroundColor!: string;

  @Prop({ default: () => 10 })
  private readonly strokeWidth!: number;

  @Prop({ default: () => 85 })
  private readonly radius!: number;

  @Prop({ default: () => 200 })
  private readonly width!: number;

  @Prop({ default: () => 200 })
  private readonly height!: number;

  @Prop({ default: () => false })
  private readonly visibleValue!: boolean;

  @Prop({ default: () => "" })
  private readonly emptyText!: string;

  @Prop({ default: () => "" })
  private readonly classValue!: string;

  @Prop({ default: () => "" })
  private readonly customText!: string;

  @Prop({ default: () => false })
  private readonly passTextAsHtml!: boolean;

  private get isDark(): boolean {
    return this.$vuetify.theme.dark;
  }

  private get backgroundColor(): string {
    return this.isDark ? "#ecf6ff" : "#003858";
  }

  // If more than 50% filled we need to switch arc drawing mode from less than 180 deg to more than 180 deg
  private get largeArc(): 0 | 1 {
    return this.percent < 50 ? 0 : 1;
  }

  // Where to put x coordinate of center of circle
  private get x(): number {
    return 100;
  }

  // Where to put y coordinate of center of circle
  private get y(): number {
    return 100 - this.radius;
  }

  // Calculate X coordinate of end of arc (+ 100 to move it to middle of image)
  // add some rounding error to make arc not disappear at 100%
  private get endX(): number {
    return -Math.sin(this.radians) * this.radius + 100 - 0.0001;
  }

  // Calculate Y coordinate of end of arc (+ 100 to move it to middle of image)
  private get endY(): number {
    return Math.cos(this.radians) * this.radius + 100;
  }

  // Calculate length of arc in radians
  private get radians(): number {
    const degrees = (this.percent / 100) * 360;
    const value = degrees - 180; // Turn the circle 180 degrees counter clockwise
    return (value * Math.PI) / 180;
  }

  // If we reach full circle we need to complete the circle, this ties into the rounding error in X coordinate above
  private get z(): "z" | "" {
    return this.percent === 100 ? "z" : "";
  }

  private get dBg(): string {
    return `M ${this.x} ${this.y} A ${this.radius} ${this.radius} 0 1 1 ${this.x - 0.0001} ${this.y} z`;
  }

  private get d(): string {
    return `M ${this.x} ${this.y} A ${this.radius} ${this.radius} 0 ${this.largeArc} 1 ${this.endX} ${this.endY} ${this.z}`;
  }

  private get valueFromBottom(): number {
    if (this.strokeWidth < 15) {
      return this.height / 2 - this.strokeWidth / 1.5;
    } else {
      return this.height / 2 - this.strokeWidth / 3;
    }
  }

  private get valueFromLeft(): number {
    return this.width / 2 - this.strokeWidth;
  }

  private get valueStyle() {
    return {
      color: this.foregroundColor,
      bottom: `${this.valueFromBottom}px`,
      left: `${this.valueFromLeft}px`,
      position: "absolute",
      "font-size": "18px",
    };
  }

  private get visibleEmptyText(): boolean {
    return this.percent === 0 && this.emptyText !== "";
  }

  private get customTextStyle() {
    return {
      color: this.foregroundColor,
      width: `${this.width}px`,
      // height: `${this.height}px`,
      height: `${this.height / 3 + this.strokeWidth / 3 + 10}px`,
      bottom: `${this.height / 2 - this.strokeWidth * 3}px`,
      left: 0,
      position: "absolute",
      verticalAlign: "middle",
      wordBreak: "break-all",
      wordWrap: "break-word",
      fontSize: "33px",
      textAlign: "center",
    };
  }
}
